import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { CommonModule } from '@angular/common'; // Importa CommonModule

@Component({
  selector: 'app-preguntas-frecuentes',
  standalone: true,
  imports: [CommonModule], // Agrega CommonModule para que *ngFor funcione
  templateUrl: './preguntas-frecuentes.component.html',
  styleUrl: './preguntas-frecuentes.component.scss'
})
export class PreguntasFrecuentesComponent implements OnInit {

  faqs = [
    {
      question: '¿Qué tipo de uniformes adventistas venden?',
      answer: 'Somos especialistas en la fabricación de uniformes completos y oficiales para los distintos clubes y ministerios. Manejamos uniformes para: Club de Guías Mayores, Club de Conquistadores, Club de Aventureros, Ministerio de la Mujer y Ministerio Infantil.',
      open: false
    },
    {
      question: '¿Fabrican uniformes personalizados o solo venden los modelos estándar?',
      answer: 'Nos enfocamos en la fabricación de los uniformes oficiales y reglamentarios. Esto asegura que cada prenda cumpla con los estándares de calidad y diseño requeridos por la organización. Si necesitas un uniforme completo, individual o con insignias, podemos ayudarte.',
      open: false
    },
    {
      question: '¿También venden la ropa casual y juvenil?',
      answer: 'Sí. Además de nuestros uniformes adventistas, contamos con un equipo de diseñadores de moda que crea una línea de ropa casual y juvenil. Cada pieza está elaborada con telas de alta calidad para ofrecerte comodidad, estilo y un diseño a la vanguardia.',
      open: false
    },
    {
      question: '¿Tienen insignias, parches de especialidades y otros accesorios?',
      answer: 'Sí, ofrecemos una gran variedad de accesorios para complementar tu uniforme. Contamos con parches de especialidades a precios competitivos, así como las insignias necesarias para que tu uniforme esté completo y listo para usarse.',
      open: false
    },
    {
      question: '¿Cómo puedo consultar el precio de los uniformes y la ropa?',
      answer: 'Puedes encontrar los precios de nuestros uniformes y prendas en la sección de uniformes y en nuestra sección de ropa casual. Si necesitas una cotización personalizada o tienes dudas, puedes contactarnos directamente por WhatsApp.',
      open: false
    },
    {
      question: '¿Utilizan telas sustentables en la fabricación de su ropa?',
      answer: 'Sí. En **CAMBEN**, nuestro compromiso con el planeta es una prioridad. Por ello, en la fabricación de nuestra ropa casual y uniformes, utilizamos telas sustentables y materiales de alta calidad, garantizando no solo un producto duradero, sino también un proceso de producción más amigable con el medio ambiente.',
      open: false
    },
    {
      question: '¿Realizan envíos a toda la República Mexicana? ¿Dónde se ubican?',
      answer: 'Sí, realizamos envíos a toda la República Mexicana con cobertura garantizada, para que no tengas que preocuparte por la distancia. Aunque nuestra fábrica está ubicada en Juarez, Nuevo León, la tienda en línea te permite comprar de forma segura y recibir tu pedido en la puerta de tu casa.',
      open: false
    },
    {
      question: '¿Tienen promociones o precios especiales?',
      answer: 'Constantemente tenemos promociones y precios especiales en uniformes, combos y parches, especialmente en temporadas de alta demanda. Te invitamos a seguirnos en nuestras redes sociales y a visitar nuestro sitio web para estar al tanto de las ofertas vigentes.',
      open: false
    }
  ];

  constructor(private titleService: Title, private metaService: Meta) { }

  ngOnInit(): void {
    // SEO: Título y meta etiquetas para la página de FAQ
    this.titleService.setTitle('Preguntas Frecuentes | Uniformes Adventistas y Ropa Casual | CAMBEN');
    this.metaService.addTags([
      { name: 'description', content: 'Encuentra las respuestas a tus preguntas sobre uniformes adventistas, ropa casual, precios, envíos y más en nuestra sección de preguntas frecuentes.' },
      { name: 'keywords', content: 'preguntas frecuentes, FAQ, uniformes adventistas, Conquistadores, Guías Mayores, ropa casual, envíos, telas sustentables, CAMBEN' },
      { property: 'og:title', content: 'Preguntas Frecuentes | CAMBEN' },
      // ... otras meta etiquetas si las necesitas
    ]);
  }

  // Método para alternar la visibilidad de la respuesta
  toggleFaq(faq: any): void {
    faq.open = !faq.open;
  }
}